import React, { Component } from 'react';
import config from '../../config';

class Page extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const loginUrl = `${config.endpoint}/login`;
        return (
            <div>
                <p>{this.props.msg}</p>
                <p><a href={loginUrl}>再認証する</a></p>
            </div>
        );
    }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/error/index.js